import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { Spin, Select } from "antd";
import DynamicPieChart from "../../pieChart";
import DynamicColumnChart from "../../columnChart";
import DynamicBarChart from "../../barChart";
import DynamicLineChart from "../../lineChart";

const { Option } = Select;

const TotalGrainsPurchased = ({ isMaximized, openMaximize }) => {
  const [loading, setLoading] = useState(true);

  const [totalQty, setTotalQty] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  const [dataCrop, setDataCrop] = useState([]);
  const [dataState, setDataState] = useState([]);

  const [viewType, setViewType] = useState("crop");
  const [valueType, setValueType] = useState("qty");
  const [chartType, setChartType] = useState("pie");

  const [selectedCrop, setSelectedCrop] = useState("all");
  const [selectedState, setSelectedState] = useState("all");

  const { sendRequest: fetchData } = useHttp();

  useEffect(() => {
    const url = `/api/totalGrainsPurchased/?userId=${localStorage.getItem(
      "id"
    )}&orgId=${localStorage.getItem("orgId")}`;

    fetchData({ url }, (res) => {
      setTotalQty(res.totalQty || 0);
      setTotalPrice(res.totalPrice || 0);
      setDataCrop(res.qtyPerCrop || []);
      setDataState(res.qtyPerState || []);
      setLoading(false);
    });
  }, [fetchData]);

  
  let filteredData = [];

  if (viewType === "crop") {
    filteredData =
      selectedCrop === "all"
        ? dataCrop
        : dataCrop.filter((c) => c.cropName === selectedCrop);
  } else {
    filteredData =
      selectedState === "all"
        ? dataState
        : dataState.filter((s) => s.state === selectedState);
  }

  let displayValue = valueType === "qty" ? totalQty : totalPrice;

  if (viewType === "crop" && selectedCrop !== "all") {
    const rows = dataCrop.filter((c) => c.cropName === selectedCrop);
    displayValue = rows.reduce(
      (sum, r) =>
        sum + (valueType === "qty" ? r.totalQty || 0 : r.totalPrice || 0),
      0
    );
  }

  if (viewType === "state" && selectedState !== "all") {
    const row = dataState.find((s) => s.state === selectedState);
    displayValue =
      valueType === "qty" ? row?.totalQty || 0 : row?.totalPrice || 0;
  }

  const chartYField = valueType === "qty" ? "totalQty" : "totalPrice";

  if (isMaximized) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "20px",
          background: "#f1f9e8",
          borderRadius: "14px",
        }}
      >
        <div className="flex justify-between mb-5">

          <Select
            value={viewType}
            style={{ width: 180 }}
            onChange={(v) => {
              setViewType(v);
              setSelectedCrop("all");
              setSelectedState("all");
            }}
          >
            <Option value="crop">Crop Wise</Option>
            <Option value="state">State Wise</Option>
          </Select>

          {viewType === "crop" && (
            <Select
              value={selectedCrop}
              style={{ width: 220 }}
              onChange={(v) => setSelectedCrop(v)}
            >
              <Option value="all">All Crops</Option>
              {dataCrop.map((c, i) => (
                <Option key={i} value={c.cropName}>
                  {c.cropName || "N/A"}
                </Option>
              ))}
            </Select>
          )}

          {viewType === "state" && (
            <Select
              value={selectedState}
              style={{ width: 220 }}
              onChange={(v) => setSelectedState(v)}
            >
              <Option value="all">All States</Option>
              {dataState.map((s, i) => (
                <Option key={i} value={s.state}>
                  {s.state}
                </Option>
              ))}
            </Select>
          )}

          <Select
            value={chartType}
            style={{ width: 160 }}
            onChange={(v) => setChartType(v)}
          >
            <Option value="pie">Pie Chart</Option>
            <Option value="column">Column Chart</Option>
            <Option value="bar">Bar Chart</Option>
            <Option value="line">Line Chart</Option>
          </Select>
        </div>

        <div
          style={{
            textAlign: "center",
            marginBottom: "14px",
            padding: "10px",
            background: "#d6efd3",
            borderRadius: "12px",
          }}
        >
          <h1 style={{ fontSize: "32px", fontWeight: "700", color: "#1f4e1e" }}>
            {displayValue.toLocaleString()} Kg
          </h1>
          <h2 style={{ fontSize: "22px", fontWeight: "600", color: "#1f4e1e" }}>
            ₹ {totalPrice.toLocaleString()}
          </h2>
        </div>

        {chartType === "pie" && (
          <DynamicPieChart
            data={filteredData}
            angleField="totalQty"
            colorField={viewType === "crop" ? "cropName" : "state"}
            isMaximized={true}
          />
        )}

        {chartType === "column" && (
          <DynamicColumnChart
            data={filteredData}
            xField={viewType === "crop" ? "cropName" : "state"}
            yField={chartYField}
            seriesField={viewType === "crop" ? "cropName" : "state"}
          />
        )}

        {chartType === "bar" && (
          <DynamicBarChart
            data={filteredData}
            xField={viewType === "crop" ? "cropName" : "state"}
            yField={chartYField}
            seriesField={viewType === "crop" ? "cropName" : "state"}
          />
        )}

        {chartType === "line" && (
          <DynamicLineChart
            data={filteredData}
            xField={viewType === "crop" ? "cropName" : "state"}
            yField={chartYField}
            seriesField={viewType === "crop" ? "cropName" : "state"}
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl shadow-md"
      style={{
        background: "#f3e8d3",
        height: "200px",
        width: "100%",
        padding: "18px",
        position: "relative",
      }}
    >
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <Spin />
        </div>
      ) : (
        <>
          <div style={{ textAlign: "center" }}>
            <h1 style={{ fontSize: "32px", fontWeight: "700", color: "#1f4e1e" }}>
              {totalQty.toLocaleString()} Kg
            </h1>
            <h2
              style={{
                fontSize: "22px",
                fontWeight: "600",
                color: "#1f4e1e",
                marginTop: "4px",
              }}
            >
              ₹ {totalPrice.toLocaleString()}
            </h2>
            <p style={{ fontSize: "17px", marginTop: "6px", color: "#1f4e1e" }}>
              Total Grains Purchased
            </p>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "8px",
              right: "18px",
              cursor: "pointer",
              fontWeight: "600",
              color: "#1f4e1e",
            }}
            onClick={openMaximize}
          >
            More...
          </div>
        </>
      )}
    </div>
  );
};

export default TotalGrainsPurchased;
